export const categories = [
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-line', description: '热门电视剧全集在线观看' },
  { slug: 'dianying', name: '电影', icon: 'ri-film-line', description: '最新大片高清免费' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-emotion-happy-line', description: '热门综艺节目推荐' },
  { slug: 'dongman', name: '动漫', icon: 'ri-rocket-line', description: '动漫番剧在线播放' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-global-line', description: '精彩纪录片合集' },
  { slug: 'duanju', name: '短剧', icon: 'ri-smartphone-line', description: '热门短剧爽看' },
];

export const videos = [
  {
    id: 1,
    title: '繁花',
    category: 'dianshiju',
    categoryName: '电视剧',
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20period%20drama%20poster%20style%20image%2C%20Shanghai%20in%201990s%2C%20warm%20golden%20amber%20tones%2C%20nostalgic%20atmosphere%2C%20elegant%20composition%2C%20cinematic%20lighting%2C%20soft%20bokeh%20background%2C%20vintage%20aesthetic&width=600&height=800&seq=video-01&orientation=portrait',
    rating: 9.3,
    year: 2024,
    description: '九十年代的上海处处是机遇与希望，阿宝凭借改革开放的春风和自己的打拼，跻身成为商界后起之秀。',
    tags: ['热门', '沪语', '商战'],
    isHot: true,
  },
  {
    id: 2,
    title: '庆余年 第二季',
    category: 'dianshiju',
    categoryName: '电视剧',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%20with%20warm%20autumn%20tones%2C%20ancient%20Chinese%20palace%20aesthetic%2C%20dramatic%20lighting%2C%20soft%20golden%20amber%20background%2C%20cinematic%20composition&width=600&height=800&seq=video-02&orientation=portrait',
    rating: 8.9,
    year: 2024,
    description: '范闲面临内库的严峻考验，同时身世之谜也逐渐浮出水面。',
    tags: ['热播', '古装', '权谋'],
    isHot: true,
  },
  {
    id: 3,
    title: '狂飙',
    category: 'dianshiju',
    categoryName: '电视剧',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20poster%2C%20dark%20tone%20with%20warm%20highlights%2C%20urban%20night%20setting%2C%20dramatic%20contrast%20lighting%2C%20cinematic%20movie%20poster%20style%2C%20intense%20atmosphere&width=600&height=800&seq=video-03&orientation=portrait',
    rating: 9.1,
    year: 2023,
    description: '京海市一线刑警安欣与黑恶势力长达二十年的生死搏斗。',
    tags: ['高口碑', '犯罪', '剧情'],
    isHot: true,
  },
  {
    id: 4,
    title: '流浪地球2',
    category: 'dianying',
    categoryName: '电影',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20blockbuster%20movie%20poster%2C%20space%20theme%2C%20futuristic%20technology%2C%20warm%20orange%20and%20amber%20lighting%2C%20epic%20cinematic%20scale%2C%20dramatic%20composition%2C%20clean%20background&width=600&height=800&seq=video-04&orientation=portrait',
    rating: 8.5,
    year: 2023,
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，开启流浪地球计划。',
    tags: ['科幻', '巨制', '国产'],
    isHot: true,
  },
  {
    id: 5,
    title: '热辣滚烫',
    category: 'dianying',
    categoryName: '电影',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%2C%20warm%20vibrant%20colors%2C%20energetic%20mood%2C%20boxing%20theme%2C%20inspirational%20atmosphere%2C%20soft%20gradient%20background%2C%20cinematic%20portrait%20style&width=600&height=800&seq=video-05&orientation=portrait',
    rating: 7.8,
    year: 2024,
    description: '宅家多年的杜乐莹结识拳击教练后，克服困难开启滚烫人生的故事。',
    tags: ['喜剧', '励志', '热门'],
    isHot: false,
  },
  {
    id: 6,
    title: '封神第一部',
    category: 'dianying',
    categoryName: '电影',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20movie%20poster%2C%20ancient%20Chinese%20warriors%2C%20warm%20bronze%20and%20gold%20tones%2C%20dramatic%20battle%20scene%2C%20cinematic%20lighting%2C%20epic%20fantasy%20composition&width=600&height=800&seq=video-06&orientation=portrait',
    rating: 8.1,
    year: 2023,
    description: '商王殷寿暴虐无道，姬发觉醒踏上封神之路的东方神话史诗。',
    tags: ['神话', '史诗', '巨制'],
    isHot: false,
  },
  {
    id: 7,
    title: '奔跑吧 第八季',
    category: 'zongyi',
    categoryName: '综艺',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20outdoor%20adventure%20theme%2C%20bright%20warm%20sunny%20colors%2C%20playful%20and%20energetic%20atmosphere%2C%20group%20of%20celebrities%2C%20fun%20composition&width=600&height=800&seq=video-07&orientation=portrait',
    rating: 7.5,
    year: 2024,
    description: '兄弟团再度集结，全新游戏挑战带来更多欢笑和感动。',
    tags: ['热门', '户外', '真人秀'],
    isHot: true,
  },
  {
    id: 8,
    title: '歌手2024',
    category: 'zongyi',
    categoryName: '综艺',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20show%20poster%2C%20stage%20performance%20lighting%2C%20warm%20golden%20spotlight%2C%20musical%20atmosphere%2C%20elegant%20and%20dramatic%20composition%2C%20concert%20vibe&width=600&height=800&seq=video-08&orientation=portrait',
    rating: 8.0,
    year: 2024,
    description: '顶级歌手同台竞技，带来震撼人心的音乐盛宴。',
    tags: ['音乐', '竞技', '热门'],
    isHot: true,
  },
  {
    id: 9,
    title: '斗罗大陆2',
    category: 'dongman',
    categoryName: '动漫',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20poster%2C%20fantasy%20martial%20arts%20theme%2C%20warm%20golden%20and%20amber%20energy%20effects%2C%20dynamic%20action%20pose%2C%20beautiful%20character%20design%2C%20epic%20fantasy%20world&width=600&height=800&seq=video-09&orientation=portrait',
    rating: 8.7,
    year: 2024,
    description: '唐三带领史莱克七怪征战世界，魂师大赛精彩继续。',
    tags: ['国漫', '热血', '玄幻'],
    isHot: true,
  },
  {
    id: 10,
    title: '凡人修仙传',
    category: 'dongman',
    categoryName: '动漫',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20donghua%20poster%2C%20ancient%20Chinese%20fantasy%20world%2C%20warm%20misty%20mountain%20background%2C%20mystical%20atmosphere%2C%20sword%20and%20magic%2C%20cinematic%20lighting&width=600&height=800&seq=video-10&orientation=portrait',
    rating: 8.4,
    year: 2023,
    description: '平凡少年韩立踏入修仙之路，在残酷的修真界中步步为营。',
    tags: ['修仙', '国漫', '经典'],
    isHot: false,
  },
  {
    id: 11,
    title: '地球脉动 第三季',
    category: 'jilupian',
    categoryName: '纪录片',
    image: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%2C%20stunning%20wildlife%20photography%2C%20warm%20natural%20sunlight%2C%20golden%20hour%20landscape%2C%20beautiful%20animal%20in%20natural%20habitat%2C%20cinematic%20quality&width=600&height=800&seq=video-11&orientation=portrait',
    rating: 9.6,
    year: 2023,
    description: '从海洋深处到最偏远的丛林，呈现自然界最壮丽的奇观。',
    tags: ['BBC', '自然', '高分'],
    isHot: false,
  },
  {
    id: 12,
    title: '隐秘的角落',
    category: 'dianshiju',
    categoryName: '电视剧',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20suspense%20thriller%20drama%20poster%2C%20dark%20moody%20atmosphere%2C%20warm%20amber%20street%20light%2C%20mystery%20and%20tension%2C%20cinematic%20composition%2C%20urban%20night%20scene&width=600&height=800&seq=video-12&orientation=portrait',
    rating: 8.8,
    year: 2020,
    description: '三个孩子在景区游玩时无意间拍摄记录了一场谋杀，他们的冒险从此开始。',
    tags: ['悬疑', '高分', '经典'],
    isHot: false,
  },
  {
    id: 13,
    title: '长安三万里',
    category: 'dianying',
    categoryName: '电影',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20historical%20movie%20poster%2C%20Tang%20dynasty%20ancient%20China%2C%20warm%20golden%20sunset%20tones%2C%20poetic%20atmosphere%2C%20beautiful%20traditional%20aesthetic%2C%20cinematic&width=600&height=800&seq=video-13&orientation=portrait',
    rating: 8.3,
    year: 2023,
    description: '安史之乱后，高适回忆与李白的一生往事，展现大唐盛世风采。',
    tags: ['动画', '历史', '诗意'],
    isHot: false,
  },
  {
    id: 14,
    title: '王牌对王牌 第八季',
    category: 'zongyi',
    categoryName: '综艺',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20game%20variety%20show%20poster%2C%20studio%20stage%20with%20colorful%20warm%20lighting%2C%20fun%20and%20entertaining%20atmosphere%2C%20celebrities%20playing%20games%2C%20bright%20composition&width=600&height=800&seq=video-14&orientation=portrait',
    rating: 7.3,
    year: 2024,
    description: '经典IP对决，王牌家族与嘉宾们带来欢乐无限的综艺盛宴。',
    tags: ['游戏', '经典IP', '情怀'],
    isHot: false,
  },
  {
    id: 15,
    title: '完美世界',
    category: 'dongman',
    categoryName: '动漫',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20donghua%20poster%2C%20epic%20battle%20scene%2C%20warm%20fiery%20energy%20effects%2C%20ancient%20mythological%20world%2C%20dynamic%20action%2C%20cinematic%20lighting%2C%20golden%20amber%20tones&width=600&height=800&seq=video-15&orientation=portrait',
    rating: 8.5,
    year: 2024,
    description: '石昊在大荒中崛起，踏上成为荒天帝的传奇之路。',
    tags: ['国漫', '玄幻', '战斗'],
    isHot: false,
  },
  {
    id: 16,
    title: '河西走廊',
    category: 'jilupian',
    categoryName: '纪录片',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20documentary%20poster%2C%20ancient%20Silk%20Road%20landscape%2C%20warm%20desert%20golden%20hour%20lighting%2C%20vast%20mountain%20and%20desert%20scenery%2C%20cinematic%20grand%20scale&width=600&height=800&seq=video-16&orientation=portrait',
    rating: 9.7,
    year: 2015,
    description: '讲述河西走廊自汉代至今两千多年来的历史变迁与文明交融。',
    tags: ['历史', '文化', '神作'],
    isHot: false,
  },
];

export const articles = [
  {
    id: 1,
    title: '2024年最值得期待的国产剧大盘点：从古装权谋到现代悬疑应有尽有',
    slug: '2024-best-chinese-dramas',
    excerpt: '今年国产剧市场异常热闹，各类题材百花齐放。从《庆余年2》的权谋智斗到《繁花》的商海沉浮，我们为你整理了最值得一看的好剧。',
    content: `<p>2024年的国产剧市场可谓是近年来最为繁荣的一年。从年初的《繁花》开始，一部又一部精品剧集接连问世，让观众大呼过瘾。</p>
    <h2>古装权谋类：《庆余年第二季》</h2>
    <p>作为2019年现象级爆款《庆余年》的续作，第二季在观众的千呼万唤中终于登场。剧情承接上季，范闲面临的挑战更加严峻——内库的财政危机、身世之谜的逐渐揭开、以及与各路人马的智力较量，都让这部剧看点十足。</p>
    <h2>年代传奇类：《繁花》</h2>
    <p>王家卫导演的首部电视剧作品《繁花》无疑是一部视觉盛宴。九十年代上海的繁华与迷离，在精美的镜头语言下展现得淋漓尽致。阿宝从一个普通人到商界大亨的蜕变故事，也折射出了那个时代的机遇与挑战。</p>
    <h2>现代悬疑类：《隐秘的角落》续作</h2>
    <p>悬疑剧一直是中国观众最喜爱的类型之一。继《隐秘的角落》和《沉默的真相》之后，更多优秀的悬疑作品正在路上，让我们拭目以待。</p>
    <p>除此之外，还有多部优质剧集值得关注：现实主义题材的《大江大河3》、科幻题材的《三体》续篇、以及各类IP改编作品。国产剧的黄金时代正在到来。</p>`,
    category: 'dianshiju',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20series%20collection%20collage%20style%2C%20warm%20cinematic%20tones%2C%20various%20Chinese%20historical%20and%20modern%20drama%20posters%20arrangement%2C%20elegant%20composition%2C%20golden%20amber%20lighting&width=1200&height=600&seq=article-01&orientation=landscape',
    author: '蓝莓编辑部',
    date: '2024-07-28',
    tags: ['国产剧', '推荐', '盘点'],
  },
  {
    id: 2,
    title: '从《流浪地球2》到《封神》，国产科幻与奇幻电影的崛起之路',
    slug: 'chinese-scifi-fantasy-movies-rise',
    excerpt: '近年来国产电影在科幻和奇幻领域取得了令人瞩目的成就。《流浪地球2》和《封神第一部》等作品不仅票房大卖，更在技术和叙事上实现了突破。',
    content: `<p>曾几何时，科幻和奇幻电影被视为中国电影的短板。但近年来，这一局面发生了根本性的改变。</p>
    <h2>科幻电影的里程碑：《流浪地球》系列</h2>
    <p>《流浪地球2》作为前传，不仅延续了第一部的宏大世界观，更在视觉效果和情感深度上更进一步。影片探讨了在末日危机面前，人类如何做出选择——是数字永生还是带着家园流浪？这一深刻的哲学命题让影片超越了普通的科幻动作片。</p>
    <h2>东方神话的新生：《封神第一部》</h2>
    <p>乌尔善导演十年磨一剑的《封神》系列，将中国古典神话搬上大银幕，以史诗般的格局和精湛的特效技术，让观众重新认识了这段传奇故事。质子旅的设定、纣王与妲己关系的重新诠释，都体现了创作者的巧思。</p>
    <h2>动画电影的惊喜：《长安三万里》</h2>
    <p>追光动画的《长安三万里》则以诗意的画面和深厚的文化底蕴，展现了盛唐气象。高适与李白跨越一生的友情，让无数观众为之动容。这部作品证明了中国动画电影在艺术表达上的无限可能。</p>
    <p>国产电影正在迎来最好的时代。随着技术的不断进步和创作者的日益成熟，我们有理由相信，未来会有更多优秀的国产幻想类电影诞生。</p>`,
    category: 'dianying',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20and%20fantasy%20movies%20collage%2C%20epic%20cinematic%20scenes%2C%20warm%20dramatic%20lighting%2C%20space%20and%20mythological%20themes%20combined%2C%20golden%20and%20amber%20color%20palette&width=1200&height=600&seq=article-02&orientation=landscape',
    author: '蓝莓编辑部',
    date: '2024-07-25',
    tags: ['电影', '科幻', '奇幻'],
  },
  {
    id: 3,
    title: '国漫崛起：从《斗罗大陆》到《凡人修仙传》，国产动画的黄金时代',
    slug: 'chinese-animation-golden-age',
    excerpt: '国产动画正在迎来前所未有的发展机遇。从3D玄幻到2D古风，国漫作品的质量和数量都在快速提升，形成了独特的中国动画风格。',
    content: `<p>在过去的几年里，国产动画经历了翻天覆地的变化。从最初被质疑"低幼化"，到如今成为拥有庞大粉丝群体的内容品类，国漫的崛起有目共睹。</p>
    <h2>3D动画的领军者：《斗罗大陆》系列</h2>
    <p>作为国内最成功的3D动画IP之一，《斗罗大陆》以其精美的画面、流畅的动作设计和扣人心弦的剧情，吸引了数以亿计的观众。唐三的成长故事激励着一代年轻人。</p>
    <h2>修仙动画的标杆：《凡人修仙传》</h2>
    <p>不同于传统热血风格，《凡人修仙传》以其独特的写实画风和克制的叙事节奏，开辟了国漫的另一条道路。韩立这个"凡人"主角的谨慎与坚韧，让故事更具真实感和代入感。</p>
    <h2>玄幻世界的广阔版图：《完美世界》</h2>
    <p>《完美世界》以其宏大的世界观和精彩的战斗场面，展现了中国玄幻文化的独特魅力。石昊的传奇经历融合了中国古代神话元素，构建了一个令人神往的奇幻世界。</p>
    <p>国漫的未来令人期待。随着技术的进步和创作人才的涌现，我们有理由相信，中国动画将在这个黄金时代中继续绽放光彩。</p>`,
    category: 'dongman',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20donghua%20artwork%20collage%2C%20various%20fantasy%20characters%2C%20warm%20golden%20and%20amber%20lighting%2C%20epic%20fantasy%20scenes%2C%20beautiful%20art%20style%2C%20cinematic%20composition&width=1200&height=600&seq=article-03&orientation=landscape',
    author: '蓝莓编辑部',
    date: '2024-07-22',
    tags: ['国漫', '动画', '推荐'],
  },
  {
    id: 4,
    title: '为什么说《歌手2024》重新定义了音乐综艺？深度解析节目亮点',
    slug: 'singer-2024-music-variety-analysis',
    excerpt: '《歌手2024》以全新的赛制和顶级的音乐制作，为沉寂已久的音乐综艺市场注入了新的活力。本文深度解析节目的成功秘诀。',
    content: `<p>音乐综艺曾经是中国电视综艺的绝对王者，但近年来同质化严重，观众审美疲劳。《歌手2024》的出现，打破了这一僵局。</p>
    <h2>创新赛制：直播竞演的紧张感</h2>
    <p>与以往录播不同，《歌手2024》采用全程直播的形式，这意味着每位歌手都必须拿出真功夫，没有任何修音和重来的机会。这种真实感和紧张感让节目充满了不可预测的魅力。</p>
    <h2>顶级制作：音乐品质的极致追求</h2>
    <p>节目的音乐制作团队汇集了国内顶尖的编曲人和乐手，每一场演出都堪称音乐会级别的视听盛宴。无论是流行、摇滚还是民族音乐，都能在舞台上得到完美呈现。</p>
    <h2>多元阵容：国际化的歌手组合</h2>
    <p>节目邀请了来自不同国家、不同风格的歌手同台竞技，既有国内实力唱将，也有国际知名歌手。这种多元化的阵容让音乐风格更加丰富，也为观众带来了新鲜感。</p>
    <p>《歌手2024》的成功证明了优质内容永远是吸引观众的关键。在内容为王的时代，只有不断创新、追求卓越，才能赢得观众的心。</p>`,
    category: 'zongyi',
    coverImage: 'https://readdy.ai/api/search-image?query=Music%20stage%20performance%20with%20dramatic%20lighting%2C%20concert%20atmosphere%2C%20warm%20golden%20spotlights%2C%20singer%20on%20stage%2C%20epic%20music%20show%20production%2C%20cinematic%20wide%20shot&width=1200&height=600&seq=article-04&orientation=landscape',
    author: '蓝莓编辑部',
    date: '2024-07-20',
    tags: ['综艺', '音乐', '深度'],
  },
  {
    id: 5,
    title: '纪录片推荐：从《地球脉动》到《河西走廊》，不可错过的高分纪录片',
    slug: 'must-watch-documentaries',
    excerpt: '好的纪录片能开阔视野、增长见识。我们为你精选了几部豆瓣评分9.0以上的顶级纪录片，涵盖自然、历史、文化等多个领域。',
    content: `<p>纪录片是了解世界的一扇窗。一部优秀的纪录片不仅能带来知识的增长，更能触动心灵、引发思考。</p>
    <h2>自然之美的极致呈现：《地球脉动》系列</h2>
    <p>BBC出品的《地球脉动》系列堪称自然纪录片的巅峰之作。第三季采用了最新的拍摄技术，从8K超高清到无人机航拍，将地球最壮丽的景观和最珍稀的生物展现在观众面前。每一帧画面都像一幅精美的摄影作品。</p>
    <h2>历史文化的深情回望：《河西走廊》</h2>
    <p>这部国产纪录片以丝绸之路的重要通道——河西走廊为切入点，讲述了两千多年来这片土地上的历史变迁。精美的画面、深情的旁白、严谨的史实，让这部作品成为国产纪录片的标杆。</p>
    <h2>更多优质推荐</h2>
    <p>除了上述两部，还有《蓝色星球》、《人类星球》、《我在故宫修文物》等众多优秀纪录片值得一看。纪录片不仅能带来娱乐，更是一种提升自我的方式。</p>`,
    category: 'jilupian',
    coverImage: 'https://readdy.ai/api/search-image?query=Nature%20and%20historical%20documentary%20collage%2C%20stunning%20landscapes%20and%20wildlife%2C%20warm%20natural%20lighting%2C%20golden%20hour%20photography%2C%20beautiful%20cinematic%20shots%2C%20diverse%20ecosystems&width=1200&height=600&seq=article-05&orientation=landscape',
    author: '蓝莓编辑部',
    date: '2024-07-18',
    tags: ['纪录片', '推荐', '高分'],
  },
  {
    id: 6,
    title: '短剧时代来临：从微短剧到精品短剧的进化之路',
    slug: 'short-drama-era',
    excerpt: '短剧已经成为当下最热门的视频内容形式之一。从最初的草根创作到如今的精品化制作，短剧正在重塑人们的观剧习惯。',
    content: `<p>在快节奏的现代生活中，短剧以其精悍的形式和紧凑的剧情，迅速占领了用户的碎片时间。</p>
    <h2>短剧为什么火？</h2>
    <p>短剧的兴起与移动互联网的普及密不可分。每集3-10分钟的时长，完美契合了通勤、午休等碎片化场景。同时，"爽文"式的剧情设计和强反转的叙事节奏，让用户欲罢不能。</p>
    <h2>精品化趋势</h2>
    <p>随着越来越多的专业团队和知名演员加入短剧赛道，短剧的制作水平正在快速提升。从服化道到摄影灯光，从剧本到表演，精品短剧已经具备了与传统影视剧媲美的品质。</p>
    <h2>未来展望</h2>
    <p>短剧市场仍有巨大的增长空间。随着5G的普及和视频平台对短剧的持续投入，我们有理由相信，短剧将成为未来内容消费的重要形式之一。</p>`,
    category: 'duanju',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20vertical%20short%20video%20production%20scene%2C%20smartphone%20filming%20setup%2C%20warm%20studio%20lighting%2C%20creative%20content%20creation%2C%20cinematic%20mood%2C%20modern%20digital%20media&width=1200&height=600&seq=article-06&orientation=landscape',
    author: '蓝莓编辑部',
    date: '2024-07-15',
    tags: ['短剧', '趋势', '分析'],
  },
];